import DialogComponent from "../DialogComponent";
import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import * as PaymentService from "../../api/PaymentsService";
import {useTranslation} from "react-i18next";

function PayGameModal(props) {
    const [disableControls, setDisableControls] = useState(undefined)
    const [enoughBalance, setEnoughBalance] = useState(undefined)
    const { t } = useTranslation('translation', { keyPrefix: 'payGameModal' });

    useEffectOnce(() => PaymentService.getCurrentBalance((jres) => {
        let enoughBalance = (jres.balance >= props.price)
        setEnoughBalance(enoughBalance)
        let disableControlsBalanceReason = !enoughBalance
        if (props.disableControls === undefined) {
            setDisableControls(disableControlsBalanceReason)
        } else {
            setDisableControls(props.disableControls || disableControlsBalanceReason)
        }
    }, () => {
    }))

    function getPayButtonText() {
        return <div style={{
            display: "flex",
            flexDirection: "rows",
            alignItems: "center",
            fontWeight: "bold",
            paddingLeft: "12px",
            paddingRight: "12px",
        }}>
            <div>{props.price}</div>
            <div className={cabinetStyle.coinSmall}/>
        </div>
    }

    return (
        <>
            <DialogComponent
                onClose={props.onClose}
                onConfirm={props.onConfirm}
                title={enoughBalance ? t('pay') + props.game_name + "?" : t('notEnoughFunds') + props.game_name + "."}
                agreeButtonText={getPayButtonText()}
                disableControls={disableControls}
                successPayment={props.successPayment}
            ></DialogComponent>
        </>
    )
}

export default PayGameModal;